module.exports = __webpack_public_path__ + "static/media/exchange_games_bg_desktop.cbc0ac1a.jpg";